import BannersLink from '@components/BannersLink';
import React from 'react';
import './index.scss';
const NewsCard = ({ id, src, title, newsCategory }) => {
  return (
    <BannersLink link={`/news/${id}`} className='news-card'>
      <div className='news-card__img-wrapper'>
        <img className='news-card__img' src={src} alt={title} />
      </div>
      <div className='news-card__category'> {newsCategory} </div>
      <div className='news-card__title'> {title} </div>
    </BannersLink>
  );
};

export default NewsCard;
